let currentUser = null;

const CurrentUser = {
  initialize(userData) {
    currentUser = userData
  },

  getCurrentUser() {
    return currentUser
  },

  isAuthenticated() {
    return !!currentUser
  },

  hasGarStatus() {
    return currentUser.status === "gar"
  },

  getIdoCode() {
    return currentUser.ido_code
  },
};

export default CurrentUser;
